import React from "react";
import { Dialog } from "~/components/dialog";
import ClickSwallower from "~/click-swallower";
import Spinner from "~/components/spinner";
import styled from "@emotion/styled";

const PropertyDialog = styled(Dialog)`
  .mdc-dialog__container {
    overflow: visible;
    .mdc-dialog__surface {
      overflow: visible;
      .mdc-dialog__content {
        overflow: visible;
      }
    }
  }
`;

export const EmployeePropertyDialogButton = styled("div")`
  &:hover {
    cursor: pointer;
  }
`;

export type EmployeePropertyDialogProps = {
  children: React.ReactNode;
  open: boolean;
  setOpen: React.Dispatch<boolean>;
  loading: boolean;
};

export const EmployeePropertyDialog: React.FC<EmployeePropertyDialogProps> = ({
  children,
  open,
  setOpen,
  loading,
}) => {
  return (
    <>
      <ClickSwallower>
        <PropertyDialog
          open={open}
          onClose={() => setOpen(false)}
          data-open={open}
          portalize
        >
          {children}
        </PropertyDialog>
      </ClickSwallower>
      <Spinner open={loading} />
    </>
  );
};
